<template>
	<div class="real_box">
		<div class="search_box">
			<div class="box_line">
				<div class="line_input">
					<div class="input_title">记录时间</div>
					<el-date-picker
						size="small"
						v-model="searchDate"
						type="datetimerange"
						value-format="yyyy-MM-dd HH:mm:ss"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						style="width: 392px;"
					></el-date-picker>
				</div>
				<div class="search-btn" @click="fnSearchRecord"><span>搜索</span></div>
				<div class="search-btn orange" @click="fnSearchRecord"><span>刷新</span></div>
				<div class="title">
					<span>实时记录</span>
					<svg-icon class="close" icon-class="close" @click="fnClose" />
				</div>
			</div>
		</div>
		<div class="cont_list">
			<div class="list_title">
				<div class="title_item">
					实时起重
					<br />
					(kg)
				</div>
				<div class="title_item">
					重量百分比
					<br />
					(%)
				</div>
				<div class="title_item">
					实时人数
					<br />
					(人)
				</div>
				<div class="title_item">
					实时高度
					<br />
					(m)
				</div>
				<div class="title_item">
					高度百分比
					<br />
					(%)
				</div>
				<div class="title_item">
					实时速度
					<br />
					(m/s)
				</div>
				<div class="title_item">
					实时方向
					<br />
					(%)
				</div>
				<div class="title_item">
					实时倾斜坡度X
					<br />
					(度)
				</div>
				<div class="title_item">
					倾斜百分比X
					<br />
					(%)
				</div>
				<div class="title_item">
					实时倾斜坡度Y
					<br />
					(度)
				</div>
				<div class="title_item">
					倾斜百分比Y
					<br />
					(%)
				</div>
				<div class="title_item">前门锁状态</div>
				<div class="title_item">后门锁状态</div>
				<div class="title_item">设备状态</div>
				<div class="title_item">记录时间</div>
			</div>
			<div class="list_boxes">
				<div class="list_box">
					<div v-if="tableData">
						<div class="box_line" v-for="(item, index) in tableData" :key="index">
							<div class="list_item">{{ item.load / 10 }}</div>
							<div class="list_item">{{ item.loadPercentage }}</div>
							<div class="list_item">{{ item.peopleNumber }}</div>
							<div class="list_item">{{ item.height / 10 }}</div>
							<div class="list_item">{{ item.heightPercentage }}</div>
							<div class="list_item">{{ item.speed }}</div>
							<div class="list_item">{{ getDirection(item.direction) }}</div>
							<div class="list_item">{{ item.tiltX }}</div>
							<div class="list_item">{{ item.tiltPercentageX }}级</div>
							<div class="list_item">{{ item.tiltY }}</div>
							<div class="list_item">{{ item.tiltPercentageY }}</div>
							<div class="list_item">{{ item.frontDoorLockStatus == 0 ? '关闭' : '开启' }}</div>
							<div class="list_item">{{ item.rearDoorLockStatus == 0 ? '关闭' : '开启' }}</div>
							<div class="list_item" :title="fnElevatorStatusToText(item.status).text">
								<span v-if="fnElevatorStatusToText(item.status).status != 0" style="color: #E6A23C">{{ fnElevatorStatusToText(item.status).msg }}</span>
								<span v-else>{{ fnElevatorStatusToText(item.status).msg }}</span>
							</div>
							<div class="list_item" :title="item.record_at">
								<span>{{ item.record_at ? item.record_at : '无' }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 翻页 -->
		<div class="cont_page">
			<el-pagination
				class="pagination"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pageTotal"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request';
import APP from '@/utils/base';

export default {
	props: {
		currentElevator: {
			type: Object
		}
	},
	data() {
		return {
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			searchDate: null,
			tableData: [],
			currentElevatorNew: {
				eqptStatus: '',
				number: '',
				nowTime: ''
			}
		};
	},
	created() {
		this.fnInit();
	},
	watch: {
		currentElevator: {
			handler: function(newV, oldV) {
				if (oldV && newV) {
					if(newV.nowTime >= oldV.nowTime){
						this.fnInit();
					}
				}
				if (newV === undefined) {
					this.currentElevatorNew = {
						eqptStatus: '',
						number: '',
						nowTime: ''
					}
				} else {
					this.currentElevatorNew.eqptStatus = newV.eqptStatus;
					this.currentElevatorNew.number = newV.number;
					this.currentElevatorNew.nowTime = newV.nowTime;
					this.fnInit();
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		getDirection(_key) {
			switch (_key) {
				case 0:
					return '停止';
				case 1:
					return '向下';
				case 2:
					return '向上';
				default:
					return '无';
					break;
			}
		},
		// 更改分页内容
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearchRecord();
		},
		// 翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			if (!(this.currentElevatorNew && this.currentElevatorNew.number)) return;
			this.fnGetElevatorRecord(
				{
					number: this.currentElevatorNew.number,
					create_at: this.searchDate ? this.searchDate.join(',') : '',
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 初始化
		fnInit() {
			this.currentPage = APP.PAGE.SKIP_PAGE;
			this.pageSize = APP.PAGE.LIMIT;
			if (!(this.currentElevatorNew && this.currentElevatorNew.number)) return;
			this.fnGetElevatorRecord(
				{
					number: this.currentElevatorNew.number,
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 获取升降机装载记录
		fnGetElevatorRecord(_obj, _cb) {
			request({
				url: 'elevator/getRecord',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res.data);
				})
				.catch(err => {
					this.tableData = [];
					this.pageTotal = 0;
					// this.$message.error(err.data)
				});
		},
		// 搜索升降机吊装记录
		fnSearchRecord() {
			this.currentPage = APP.PAGE.SKIP_PAGE;
			if (!(this.currentElevatorNew && this.currentElevatorNew.number)) return;
			this.fnGetElevatorRecord(
				{
					number: this.currentElevatorNew.number,
					create_at: this.searchDate ? this.searchDate.join(',') : '',
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.query;
					this.pageTotal = res.count;
				}
			);
		},
		// 关闭当前组件
		fnClose() {
			this.$parent.fnOpenHome();
		},
		// 升降机运行状态
		fnElevatorStatusToText(_status) {
			return APP.fnCraneStatusToText(_status, 'elevator');
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.real_box {
	width: 1600px;
	height: 778px;
}
.search_box {
	height: 40px;
	width: 1600px;
	margin-bottom: 10px;
	@include flex-box(center, center);
	.box_line {
		width: 1580px;
		height: 32px;
		position: relative;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
		}
		.title {
			position: absolute;
			right: 20px;
			@include flex-box(center, center);
			span {
				color: #3a8ee6;
				font-size: 24px;
				margin-right: 20px;
			}
		}
	}
}
.cont_list {
	width: 1580px;
	margin: 0 10px;
	height: 660px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);

	.list_title {
		width: 1580px;
		height: 48px;
		background: url(../../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);

		.title_item {
			height: 48px;
			text-align: center;
			@include flex-box(center, center);

			&:nth-child(1) {
				width: 78px;
				margin: 0 2px 0 20px;
			}

			&:nth-child(2) {
				width: 106px;
				margin: 0 2px;
			}

			&:nth-child(3) {
				width: 76px;
				margin: 0 2px;
			}

			&:nth-child(4) {
				width: 76px;
				margin: 0 2px;
			}

			&:nth-child(5) {
				width: 96px;
				margin: 0 2px;
			}

			&:nth-child(6) {
				width: 76px;
				margin: 0 2px;
			}

			&:nth-child(7) {
				width: 86px;
				margin: 0 2px;
			}

			&:nth-child(8) {
				width: 126px;
				margin: 0 2px;
			}

			&:nth-child(9) {
				width: 106px;
				margin: 0 2px;
			}

			&:nth-child(10) {
				width: 126px;
				margin: 0 2px;
			}
			&:nth-child(11) {
				width: 106px;
				margin: 0 2px;
			}
			&:nth-child(12) {
				width: 96px;
				margin: 0 2px;
			}
			&:nth-child(13) {
				width: 96px;
				margin: 0 2px;
			}
			&:nth-child(14) {
				width: 76px;
				margin: 0 2px;
			}
			&:nth-child(15) {
				width: 158px;
				margin: 0 20px 0 2px;
			}
		}
	}

	.list_boxes {
		width: 1540px;
		margin-left: 20px;
		height: 612px;
		position: relative;
		overflow: hidden;

		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;

			.box_line {
				width: 1540px;
				height: 70px;
				margin-top: 5px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					@include flex-box(center, center);

					&:nth-child(1) {
						width: 78px;
						margin-right: 2px;
					}

					&:nth-child(2) {
						width: 106px;
						margin: 0 2px;
					}

					&:nth-child(3) {
						width: 76px;
						margin: 0 2px;
					}

					&:nth-child(4) {
						width: 76px;
						margin: 0 2px;
					}

					&:nth-child(5) {
						width: 96px;
						margin: 0 2px;
					}

					&:nth-child(6) {
						width: 76px;
						margin: 0 2px;
					}

					&:nth-child(7) {
						width: 86px;
						margin: 0 2px;
					}

					&:nth-child(8) {
						width: 126px;
						margin: 0 2px;
					}

					&:nth-child(9) {
						width: 106px;
						margin: 0 2px;
					}

					&:nth-child(10) {
						width: 126px;
						margin: 0 2px;
					}
					&:nth-child(11) {
						width: 106px;
						margin: 0 2px;
					}
					&:nth-child(12) {
						width: 96px;
						margin: 0 2px;
					}
					&:nth-child(13) {
						width: 96px;
						margin: 0 2px;
					}
					&:nth-child(14) {
						width: 76px;
						margin: 0 2px;
					}
					&:nth-child(15) {
						width: 158px;
						margin-left: 2px;
					}
				}
			}
		}
	}
}
.cont_page {
	width: 1564px;
	height: 30px;
	margin-left: 21px;
	margin-top: 30px;

	>>> .el-pagination__total {
		color: #439fe3;
		font-size: 14px !important;
	}

	>>> .el-input__inner {
		background-color: rgba(49, 88, 128, 0.5) !important;
		border: none !important;
		color: #439fe3 !important;
	}

	>>> .el-pagination__jump {
		color: #439fe3;
		font-size: 14px !important;
	}

	>>> .el-select__caret {
		color: #439fe3;
	}

	>>> .el-pagination.is-background .btn-prev {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}

	>>> .el-pagination.is-background .btn-prev:disabled {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}

	>>> .el-pagination.is-background .btn-next {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}

	>>> .el-pagination.is-background .btn-next:disabled {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}

	>>> .el-pagination.is-background .el-pager li {
		color: #439fe3;
		background-color: rgba(49, 88, 128, 0.5) !important;
	}

	>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #50aaff !important;
		color: #091027;
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;

		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}

		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}

		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}

		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}

	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Elevator/elevatorDefault/components/realTimeRecord.vue